import { render, staticRenderFns } from "./TransferCheckoutCardSkeleton.vue?vue&type=template&id=fe83f9f0&scoped=true"
import script from "./TransferCheckoutCardSkeleton.vue?vue&type=script&lang=js"
export * from "./TransferCheckoutCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TransferCheckoutCardSkeleton.vue?vue&type=style&index=0&id=fe83f9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe83f9f0",
  null
  
)

export default component.exports